<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style>
@import "./assets/common/font.css";

*{
    padding: 0;
    margin: 0;
    font-family: "Montserrat-SemiBold", "Microsoft YaHei", sans-serif;
}
#app {
    padding: 0;
    margin: 0;
    font-family: "Montserrat-SemiBold", "Microsoft YaHei", sans-serif;
}
.app-nav::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #eaeaea;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  background: #fff;
}
</style>
